module.exports = __webpack_public_path__ + "media/us.ae656592.svg";